var BaseViews = require('../base');
var SpinnerButton = require('treeline-shared-components/spinner-button');

require('./cart-location-display/cart-location-display.scss');

var CartLocationDisplay = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-location-display',
    template: require('./cart-location-display/cart-location-display.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                alignment: 'horizontal',
                _appChannel: null,
                hidePhotoSmallScreen: true,
                model: null,
                actionButton: false,
                buttonText: 'Select',
                clickableLocationInfo: false
            }
        );
    },
    events: {
      'click': 'onClicked',
    },
    onClicked: function () {
      if (this.options.clickableLocationInfo == true) {
        this.trigger('info:clicked', this.model);
      }
    },
    regions: {
      buttonRegion: '.fmcy-cart-location-display-button-region'
    },
    serializeData: function () {
      // if a location model is passed in, used it.
      if (this.options.model) {
        this.model = this.options.model;
      } else {
        // no model check for current filtered location
        this.model = this.options._appChannel.request('get:filter:location:details');
      }
      var dayOfTheWeek = moment().format('dddd').toLowerCase();
      var isOpen = this.model.get('hours_' + dayOfTheWeek + '_open');
      var startTime = this.model.get('hours_' + dayOfTheWeek + '_start_time');
      var endTime = this.model.get('hours_' + dayOfTheWeek + '_end_time');

      var hours;

      if (isOpen === '1' && startTime !== null && startTime !== '' && endTime !== null && endTime !== '') {
        hours = startTime.replace(':00', '') + ' to ' + endTime.replace(':00', '');
      } else {
        hours = 'Closed';
      }

      if ((parseInt(this.model.get('temp_closed')) === 1 || this.model.get('temp_closed') == true)) {
        if (this.model.get('temp_closed_message') && this.model.get('temp_closed_message') !== '') {
          hours = this.model.get('temp_closed_message');
        } else {
          hours = 'Temporarily closed';
        }
      }

      return {
        name: this.model.get('name'),
        line_1: this.model.get('line_1'),
        city: this.model.get('city'),
        imageUrl: this.model.get('image_medium_url'),
        hours: hours
      }
    },
    _renderActionButton: function () {
      var self = this;
      var selectButton = new SpinnerButton.SpinnerButton({
          label: this.options.buttonText,
          enabled: true,
          theme: SpinnerButton.THEMES.PRIMARY,
          onClickedCallback: function () {
            self.trigger('item:clicked', self.model);
          }
      });
      this.buttonRegion.show(selectButton);
    },
    onRender: function() {
      var self = this;
      this.$el.addClass('farm-cart-location-thumb-alignment-' + this.options.alignment);

      if (this.options.hidePhotoSmallScreen) {
        this.$el.addClass('farm-location-hide-photo-small-size');
      }

      if (this.options.actionButton && this.model.get('temp_closed') !== '1') {
        this._renderActionButton();
      }

      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = CartLocationDisplay;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-location-display.js
 **/